import Header from "./componentes/Header";
import "./App.css";
import MesaTarea from "./componentes/MesaTarea";

function App() {
  return (
    <div className="app">
      <Header />
      <MesaTarea />
    </div>
  );
}

export default App;
